<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RNJIhs/tc-custom/9781504073103.jpg?1723836043958" alt="This image is the cover for the book Blues, Twos and Baby Shoes, The Constable Mavis Upton Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blues, Twos and Baby Shoes, The Constable Mavis Upton Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Mavis Upton returns from her adventures in <i>Whiskey Tango Foxtrot</i>, and this time she’s taking no prisoners—which is never ideal for a police officer . . .</b><br/>  <br/> Mavis is pregnant, as is her daughter Ella. Facing the prospect of motherhood and being a grandmother simultaneously, the last thing Mavis needs is problems at work.<br/>  <br/> She must contend with a new sexist dinosaur of a Sergeant who is more bully than mentor, and a mysterious case involving a blackmailer sending poison pen letters is baffling the force and tearing the local community apart.<br/>  <br/> Can Mavis juggle impending motherhood and her career, maintain a loving relationship with her other half Joe and deal with being a grandmother, all while solving the case?<br/>  <br/> Well, this is Constable Mavis Upton . . . literally anything is possible . . .<br/>  <br/><b>Series praise</b><br/>  <br/> “Laugh out loud brilliance, so witty and cleverly written.” —Samantha Magson<br/>  <br/> “Hilarious! It’s true, everyone needs Mavis in their life.” —Sherrie Hewson<br/>  <br/> “Such a terrific read!” —Lorraine Kelly
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gina Kirkham
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01d2d67a